import { FEATURES } from '@constants/Text'

export const AAWZ_DRIVE_ICONS = {
  file: 'document',
  folder: 'folder',
  delete: 'trash',
  visualize: 'eye',
  download: 'download',
  uploadFolder: 'mdi-folder-upload',
  uploadFile: 'document-upload',
  createFolder: 'folder-add',
  rename: 'edit',
  module: 'folder-cloud',
  more: 'mdi-dots-vertical',
}

export const AAWZ_DRIVE_STORAGE_USED_COLORS = {
  low: '#0B57D0',
  medium: '#F5A623',
  high: '#FF5252',
}

export const STORAGE_UPGRADE_THRESHOLD = 75

export const OPEN_FILE_PREVIEW_EXTENSIONS = [
  'pdf',
  'txt',
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'svg',
  'mp4',
  'webm',
  'mp3',
  'wav',
  'ogg',
]

export const DEFAULT_ALLOWED_EXTENSIONS = [
  'xlsx',
  'xls',
  'xlsm',
  'csv',
  'png',
  'jpg',
  'jpeg',
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'txt',
]

export const DEFAULT_ROW_HEIGHT = 36

export const AAWZ_DRIVE_MAX_FILE_SIZE_MB = 150

export const LOAD_MORE_RENDER_DELAY_MS = 100

export const AAWZ_DRIVE_FILE_ICONS_MAP = {
  pdf: { name: 'mdi-file-pdf-box', color: '#DA4033', size: '16' },
  doc: { name: 'mdi-file-word-box', color: '#3F7DE3', size: '16' },
  docx: { name: 'mdi-file-word-box', color: '#3F7DE3', size: '16' },
  csv: { name: 'mdi-file-delimited', color: '#3F7DE3', size: '16' },
  txt: { name: 'mdi-file-document', color: '#3F7DE3', size: '16' },
  md: { name: 'mdi-file-code', color: '#3F7DE3', size: '16' },
  json: { name: 'mdi-file-code', color: '#3F7DE3', size: '16' },
  ppt: { name: 'mdi-file-powerpoint-box', color: '#E7B30E', size: '16' },
  pptx: { name: 'mdi-file-powerpoint-box', color: '#E7B30E', size: '16' },
  xls: { name: 'mdi-file-excel-box', color: '#329D4E', size: '16' },
  xlsx: { name: 'mdi-file-excel-box', color: '#329D4E', size: '16' },
  xlsm: { name: 'mdi-file-excel-box', color: '#329D4E', size: '16' },
  png: { name: 'mdi-file-image', color: '#EA4335', size: '16' },
  jpg: { name: 'mdi-file-image', color: '#EA4335', size: '16' },
  jpeg: { name: 'mdi-file-image', color: '#EA4335', size: '16' },
  gif: { name: 'mdi-file-image', color: '#EA4335', size: '16' },
  svg: { name: 'mdi-file-image', color: '#EA4335', size: '16' },
  webp: { name: 'mdi-file-image', color: '#EA4335', size: '16' },
  file: { name: 'document', color: '#8E8E8E', size: '16' },
  folder: { name: 'folder', color: '#8E8E8E', size: '16' },
  zip: { name: 'mdi-zip-box', color: '#5F6368', size: '16' },
  eml: { name: 'sms', color: '#5F6368', size: '16' },
  msg: { name: 'sms', color: '#5F6368', size: '16' },
}

export const aawzDriveRoutes = (show = {}) => {
  const hasDriveAccess = !!show[FEATURES.AAWZ_DRIVE]
  const routes = [
    {
      title: 'Bem-vindo',
      subtitle: 'Conheça o AAWZ Drive e comece a organizar seus arquivos.',
      name: 'aawz-drive.welcome',
      hasAccess: true,
    },
    {
      title: 'AAWZ Drive',
      subtitle: 'Armazene, organize e compartilhe arquivos com segurança.',
      name: 'aawz-drive.files',
      hasAccess: hasDriveAccess,
    },
  ]

  return routes.filter((route) => route.hasAccess)
}
